import { render, staticRenderFns } from "./XinLvPage.vue?vue&type=template&id=9c1d27bc&scoped=true&"
import script from "./XinLvPage.vue?vue&type=script&lang=js&"
export * from "./XinLvPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1d27bc",
  null
  
)

export default component.exports